import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-monitoring",
  "use": "icon-monitoring-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-monitoring\"><path d=\"M960 224L768 381.09V256a64.19 64.19 0 0 0-64-64H128a64.19 64.19 0 0 0-64 64v512a64.19 64.19 0 0 0 64 64h576a64.19 64.19 0 0 0 64-64V642.91L960 800z\" p-id=\"33349\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol